'use client';

import { PermissionGuard } from '@/components/common/PermissionGuard';

/**
 * 扫码页面独立布局
 * 
 * 特点：
 * 1. 无左侧导航栏，全屏显示
 * 2. 权限验证：需要 parts:checkin 或 parts:checkout 权限
 * 3. 适合移动端扫码操作
 */
export default function ScanInventoryLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <PermissionGuard 
      permissions={['parts:checkin', 'parts:checkout']}
      redirectTo="/parts"
    >
      <div className="h-screen overflow-hidden">
        {children}
      </div>
    </PermissionGuard>
  );
}

